<ng-content></ng-content>

<div class="loading" *ngIf="isLoading">
  <mat-progress-spinner color="accent" diameter="32" mode="indeterminate"></mat-progress-spinner>
</div>
